<div class="modal-container main-font">
  <div class="modal-content">
    <div class="modal-title-container">
      <p class="mb-0 modal-title">Gestisci remoto</p>
      <p class="mb-0 subtitle">
        Imposta i giorni di smart working per le settimane nei mesi futuri
      </p>
    </div>
    <div class="user-container">
      <img
        [src]="_utilityService.getSanitizeUrl(user.path)"
        [alt]="user.firstName"
        class="user-image" />
      <div class="user-info">
        <p class="mb-0 text-user-name">
          {{ user.firstName }} {{ user.lastName }}
        </p>
        <p class="mb-0 text-role">{{ user.role }}</p>
      </div>
    </div>
    <!-- AGGIUNGERE COMPONENTE ALERT -->
    <app-alert [message]="msgModalDesiredSmart"></app-alert>
    <div class="input-container">
      <p class="mb-0 text-input"></p>
      <input nz-input type="number" [(ngModel)]="desiredSmart" />
    </div>
  </div>
  <div class="modal-footer w-100">
    <button class="primary-btn-outline-new w-100" (click)="closeModal()">
      Annulla
    </button>
    <button class="primary-btn-new w-100" (click)="save()">Salva</button>
  </div>
</div>
